import type { IToast } from '@components/molecules/toast'


export enum FixedActions {
    SET_TOAST = 'SET_TOAST',
}

interface setToast {
    type: typeof FixedActions.SET_TOAST
    payload: IToast
}

export type FixedActionTypes = (
    setToast
)